<div class="card p-3 pb-5 mb-5 d-flex flex-column gap-3 mt-2">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true" class="d-flex flex-column">
      <div class="d-flex align-items-center gap-3">
          <img src="https://storage.googleapis.com/komerce/assets/icons/back.svg" alt="back" (click)="back()" />
          <div class="title">User Acceptance Testing</div>
      </div>
      <div class="mt-4 py-3 px-4" style="background-color: #f8f8f8;">
          <nz-steps [nzCurrent]="current" [nzDirection]="isMediumScreen ? 'vertical' : 'horizontal'" [nzStartIndex]="0" nzSize="small" class="d-flex flex-column flex-xl-row">
            <ng-container *ngFor="let step of stepList; let i = index">
                <nz-step (click)="handleStep(i+1)" [nzTitle]="step" style="cursor: pointer;"></nz-step>
            </ng-container>
          </nz-steps>
      </div>
      <app-uat-destination [hidden]="current !== 0" />
      <app-uat-calculate-shipping [hidden]="current !== 1" />
      <app-uat-order [hidden]="current !== 2"/>
      <app-uat-pickup [hidden]="current !== 3"/>
      <app-uat-print-label [hidden]="current !== 4"/>
      <app-uat-history-awb (submitUATFinal)="updateState()" [hidden]="current !== 5"/>
  </nz-skeleton>
</div>
<app-modal-confirm-back [isShowConfirm]="isConfirmBack" [docType]="'UAT'" (isShowConfirmEvent)="closeConfirmBack()"></app-modal-confirm-back>
